export default () => ({
  externalRequest: {
    uuid: null,
    external_id: null
  }
})
